import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';

import App from './App';
import { useAuthStore } from '@/store/authStore';
import { installUploadUnloadGuard } from './services/uploadUnloadGuard';
import './index.css';

let _currentUser = '';
useAuthStore.subscribe(state => {
  _currentUser = state.user?.username ?? '';
});

const _send = (level: string, msg: string) => {
  fetch('/api/v1/logs/frontend/', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain', 'X-Log-Level': level, 'X-Log-User': _currentUser },
    body: msg,
    keepalive: true,
  }).catch(() => {});
};

const _serialize = (args: unknown[]) =>
  args.map(a => {
    try { return typeof a === 'object' && a !== null ? JSON.stringify(a) : String(a); }
    catch { return String(a); }
  }).join(' ');

(['log', 'warn', 'error'] as const).forEach(level => {
  const orig = console[level].bind(console);
  console[level] = (...args: unknown[]) => {
    orig(...args);
    _send(level, _serialize(args));
  };
});

installUploadUnloadGuard();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
